module.exports = __webpack_public_path__ + "static/media/icon-organizador.ede8dccd.svg";